export const getPropertyById = (array, property, id) => {
  if (typeof id === "string") return id;
  const item = array.find(item => item.id === id);
  return item ? item[property] : null;
};

export const getIdByProperty = (array, key, value) => {
  if (typeof value === "number") return value;
  const item = array.find(
    item => item[key].toLowerCase() === value.toLowerCase()
  );
  return item ? item["id"] : null;
};

export const valueFormatter = value => {
  return value === "" || value === null || value === undefined ? "NA" : value;
};
export const tableFormatter = (row, column) => {
  if (typeof row[column.property] === "string") {
    return row[column.property].trim() !== ""
      ? row[column.property].trim()
      : "NA";
  }
  return row[column.property] !== null ? row[column.property] : "NA";
};

export const dateTableFormatter = (row, column) => {
  return row[column.property] !== null || row[column.property] !== undefined
    ? dateFormatter(row[column.property])
    : "NA";
};

export const currencyFormat = number => {
  return number ? number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") : 0;
};
const currencyUnicodeMap = {
  naira: "20A6",
  dollar: "0024",
  pound: "00A3",
  euro: "20AC",
};
export const currencyFormatWithSymbol = number => {
  const company =
    localStorage.getItem("company") &&
    JSON.parse(localStorage.getItem("company"));
  const currency = (company && company.currency) || "naira";
  const unicode = currencyUnicodeMap[currency] || "";
  const unicodeInStringFormat = unicode
    ? JSON.parse(`["\\u${unicode}"]`)[0]
    : "";
  return number
    ? `${unicodeInStringFormat} ${number
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
    : "";
};

export const currencySymbol = () => {
  const company =
    localStorage.getItem("company") &&
    JSON.parse(localStorage.getItem("company"));
  const currency = (company && company.currency) || "naira";
  const unicode = currencyUnicodeMap[currency] || "";
  const unicodeInStringFormat = unicode
    ? JSON.parse(`["\\u${unicode}"]`)[0]
    : "";
  return unicodeInStringFormat;
};

export const tableCurrencyFormat = (row, column) => {
  let value = row[column.property];
  if (typeof value === "string") {
    value = parseFloat(value);
  }
  return value !== null
    ? value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
    : 0;
};

export const dateFormatter = (dateString, format) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  if (format) {
    return `${year}-${pad(month + 1)}-${pad(day)}`;
  }
  return `${pad(day)} - ${pad(month + 1)} - ${year}`;
};

export const dateFormatterWithMonthName = dateString => {
  const date = new Date(dateString);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(date);
  return formattedDate;
};

export const getLongMonthName = date => {
  const month = date.toLocaleString("default", { month: "long" });
  return month;
};
export const timeFormatter = (dateString, format) => {
  const date = new Date(dateString);
  let hours = date.getHours();
  const mins = date.getMinutes();
  const secs = date.getSeconds();
  const amPm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;
  if (format) {
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }
  return `${pad(hours)} : ${pad(mins)} : ${secs} ${amPm}`;
};

export const dateTimeFormatter = dateString => {
  return `${dateFormatter(dateString)}  | ${timeFormatter(dateString)}`;
};

function pad(n) {
  return n < 10 ? "0" + n : n;
}

export const capitalize = word => {
  if (typeof word !== "string") return "";
  return word.charAt(0).toUpperCase() + word.slice(1);
};

function difference(a1, a2) {
  var a2Set = new Set(a2);
  return a1.filter(function(x) {
    return !a2Set.has(x);
  });
}

export const symmetricDifference = (a1, a2) => {
  return difference(a1, a2).concat(difference(a2, a1));
};

export const routesToShow = (routes, modulesSubscribedFor) => {
  return routes.filter(x => {
    return x.name.toLowerCase() === "home" ||
      x.name.toLowerCase() === "changepassword" ||
      x.name.toLowerCase() === "support" ||
      x.name.toLowerCase() === "profile" ||
      x.name.toLowerCase() === "activity history" ||
      x.name.toLowerCase() === "dashboard"
      ? x
      : modulesSubscribedFor.find(
          y => y.slug.toLowerCase() === x.name.toLowerCase()
        );
  });
};

export const dateIncrementByHours = (startTime, increment) => {
  const date = new Date();
  const timeArray = startTime.split(":").map(x => parseInt(x.trim()));

  const hours = timeArray[0];
  const mins = timeArray[1];
  const secs = timeArray[2];

  date.setHours(hours + increment);
  date.setMinutes(mins);
  date.setSeconds(secs);
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

export function generateApproverString(approver_count) {
  return approver_count <= 0
    ? "Pending"
    : `${ordinalSuffix(approver_count)} Approver`;
}

function ordinalSuffix(digit) {
  const j = digit % 10;
  const k = digit % 100;

  if (j == 1 && k != 11) {
    return digit + "st";
  }
  if (j == 2 && k != 12) {
    return digit + "nd";
  }
  if (j == 3 && k != 13) {
    return digit + "rd";
  }
  return digit + "th";
}
